export default function determineIfCashOutNeeded(hasPrevCashOut, state){

    if(state=="TX"){
        if (hasPrevCashOut!=""&&hasPrevCashOut!=null&&hasPrevCashOut!=undefined){
            return true
        }
        else return false
    }else return true
}